import GtmDataExtractor from '@theme/gtm-data-extractor';
import { ThemeEvents, CartAddEvent, CartUpdateEvent } from '@theme/events';

/** @typedef {{ name: string, value: string }} CartOption */
/** @typedef {{ variant_id: number, quantity: number, options_with_values?: CartOption[] }} CartItem */
/** @typedef {{ items?: CartItem[], items_added?: CartItem[], items_removed?: CartItem[] }} CartResource */

//ANCHOR PAGEVIEW (INIT GA4)
GtmDataExtractor.gtmPush({ event: 'page_viewed' }).then(() => {
  //ANCHOR VIEW_ITEM
  if (window.THEME_INFO.pageType == 'product') {
    GtmDataExtractor.sendViewEvent('gtm-view-item', {
      event: 'view_item',
      method: 'load',
    });
    GtmDataExtractor.sendViewEvent('gtm-view-item-update', {
      event: 'selected_variant',
      method: 'selected',
    });
    document.addEventListener(ThemeEvents.variantUpdate, function (evt) {
      GtmDataExtractor.sendViewEvent('gtm-view-item-update', {
        event: 'selected_variant',
        method: 'selected',
      });
    });
  }
  //ANCHOR VIEW_Item_list
  if (window.THEME_INFO.pageType == 'collection') {
    GtmDataExtractor.sendViewEvent('gtm-collections', {
      event: 'view_item_list',
      method: 'load',
    });
    document.addEventListener(ThemeEvents.FilterUpdate, function () {
      GtmDataExtractor.sendViewEvent('gtm-collections', {
        event: 'view_item_list',
        method: 'refresh',
      });
    });
  }
  // ANCHOR CART_EVENTs
  document.addEventListener(ThemeEvents.cartUpdate, function (evt) {
    const cartEvt = /** @type {CartUpdateEvent} */ (evt);
    const detail = cartEvt.detail;
    if (!detail || detail.data?.didError) return;

    const cartResource = /** @type {CartResource | undefined} */ (detail.resource);
    if (!cartResource) return;

    const itemsRemoved = cartResource.items_removed ?? [];
    const itemsAdded = cartResource.items_added ?? [];

    let eventType = '';
    /** @type {CartItem[]} */
    if (itemsRemoved.length > 0) {
      eventType = 'remove_from_cart';
    } else if (itemsAdded.length > 0) {
      eventType = 'add_to_cart';
    } else {
      return;
    }
    const method = window.THEME_INFO.pageType == 'cart' ? 'cart_page' : 'sidebar';

    const changedRows = detail.data?.oldRows ?? [];
    changedRows.forEach((row) => {
      const gtmVariantId = row.dataset.gtmVariantid;
      if (!gtmVariantId) return;

      const changedItems = eventType === 'add_to_cart' ? itemsAdded : itemsRemoved;
      const changedItem = changedItems.find((item) => item.variant_id.toString() === gtmVariantId);
      const quantity = changedItem?.quantity || 0;
      const extractedData = GtmDataExtractor.getDataFromElement(row, { quantity });
      GtmDataExtractor.sendViewEvent(eventType, { event: eventType, method: method }, extractedData);
    });
  });

  document.addEventListener(CartAddEvent.eventName, function (evt) {
    const cartEvt = /** @type {CartAddEvent} */ (evt);
    const detail = cartEvt.detail;
    if (!detail || detail.data?.didError) return;

    const cartResource = /** @type {CartResource | undefined} */ (detail.resource);
    if (!cartResource) return;
    const { items_removed, items_added } = cartResource;
    if ((items_removed?.length ?? 0) > 0 || (items_added?.length ?? 0) > 0) return;

    const method = detail.data?.source === 'quick-add-inline-component' ? 'quick_shop' : 'pdp';
    const variantId = detail.sourceId || detail.data?.variantId;
    if (!variantId) return;

    const itemInCart = cartResource.items?.find((item) => item.variant_id.toString() === variantId);
    if (!itemInCart) return;

    const quantity = itemInCart.quantity;
    /** @type {Record<string, string | number>} */
    const overrideData = {
      quantity: quantity || 1,
      variantid: variantId,
    };

    let productAdded = document.querySelector(`[data-gtm-variantid="${variantId}"]`);
    if (!productAdded) {
      const productId = detail.data?.productId;
      productAdded = document.querySelector(`[data-gtm-productid="${productId}"]`);

      const size = itemInCart.options_with_values?.find((option) => option.name.toLowerCase() === 'size')?.value;
      if (size) {
        overrideData.size = size;
      }
    }

    if (!(productAdded instanceof HTMLElement)) return;

    const extractedData = GtmDataExtractor.getDataFromElement(productAdded, overrideData);
    GtmDataExtractor.sendViewEvent('add_to_cart', { event: 'add_to_cart', method: method }, extractedData);
  });
  if (window.THEME_INFO.pageType == 'search') {
    GtmDataExtractor.sendViewEvent('gtm-search', {
      event: 'search',
      method: 'load',
    });
  }
});
